import { REFRESH_TOKEN, SET_TOKEN, RefreshToken, LOGOUT, REFRESH_TOKEN_EXPIRATION_CHECK } from "../types/auth";

export const refreshTokenRequest = (token: string, callback?: () => void): RefreshToken => ({
  type: REFRESH_TOKEN,
  payload: {token, callback}
});

export const setToken = () => ({
  type: SET_TOKEN,
});

export const logout = () => ({
  type: LOGOUT,
});

export const refreshTokenExpirationCheck = () => ({
  type: REFRESH_TOKEN_EXPIRATION_CHECK,
});